export default __webpack_public_path__ + "static/media/GOV.cb85045e.png";